const form_floating_labels = () => {
    // standard text inputs and emails inputs events
    $(document).on('focus', '.gfield input[type="email"], .gfield input[type="tel"], .gfield input[type="text"]:not(.gfield .ginput_complex input[type="text"])', function() {
        $(this).closest('.gfield').addClass('focused');
    });

    $(document).on('blur', '.gfield input[type="email"], .gfield input[type="tel"], .gfield input[type="text"]:not(.gfield .ginput_complex input[type="text"])', function() {
        $(this).closest('.gfield').removeClass('focused');

        if ($(this).val().length > 0) {
            $(this).closest('.gfield').addClass('has-value');
        }

        if ($(this).val().length == 0) {
            $(this).closest('.gfield').removeClass('has-value');
        } else {
            $(this).closest('.gfield').addClass('has-value');
        }
    });

    // complex inputs (name fields) events
    $(document).on('focus', '.gfield .ginput_complex input[type="text"]',function() {
        $(this).parent().addClass('focused');
    });

    $(document).on('blur', '.gfield .ginput_complex input[type="text"]', function() {
        $(this).parent().removeClass('focused');

        if ($(this).val().length == 0) {
            $(this).parent().removeClass('has-value');
        } else {
            $(this).parent().addClass('has-value');
        }
    });

    // textarea events
    $(document).on('focus','.gfield textarea',  function() {
        $(this).closest('.gfield').addClass('focused');
    });

    $(document).on('blur','.gfield textarea', function() {
        $(this).closest('.gfield').removeClass('focused');

        if ($(this).val().length == 0) {
            $(this).closest('.gfield').removeClass('has-value');
        } else {
            $(this).closest('.gfield').addClass('has-value');
        }
    });

    // on form render add .has-value class if inputs have value
    $(document).on("gform_post_render", function (e, form_id) {
        // textarea
        $(document).find('.gfield textarea').each(function(){
            if ($(this).val().length > 0) {
                $(this).closest('.gfield').addClass('has-value');
            }
        });

        // complex inputs (name fields)
        $(document).find('.gfield .ginput_complex input[type="text"]').each(function(){
            if ($(this).val().length > 0) {
                $(this).parent().addClass('has-value');
            }
        });

        // standard text inputs and emails inputs
        $(document).find('.gfield input[type="email"], .gfield input[type="text"]:not(.gfield .ginput_complex input[type="text"])').each(function(){
            if ($(this).val().length > 0) {
                $(this).closest('.gfield').addClass('has-value');
            }
        });

        $(document).find('.address-jquery').find('input').each(function(){
            $(this).on('focus', function(){
                $(this).siblings('label').addClass('address-active');
            })

            $(this).on('blur', function(){
                if($(this).val() == "") {
                    $(this).siblings('label').removeClass('address-active');
                }
            })
        })
    });


 
}

export default form_floating_labels;